<div class="bc-email-control-panel" [@slideInFromBottomAnimation]>
  <svg-icon icon="x" (click)="onTogglePanelClick()" class="icon-close" id="toggle-email-more-actions"></svg-icon>

  <div class="container-fluid">
    <div class="control-panel-groups">
      <div class="control-panel-group control-panel-group-send">
        <a (click)="onSendAndCloseClick()" class="btn btn-dark js-reply-email-button" id="email-send-and-close-button">
          <span>{{ 'emailWorkWidget.sendAndClose' | translate }}</span>
        </a>
        <a (click)="onSendClick()" class="btn btn-light js-reply-all-email-button" id="email-send-button">
          <span>{{ 'emailWorkWidget.send' | translate }}</span>
        </a>
        <a (click)="onSubjectAndMoreClick()" class="btn btn-light js-forward-email-button" id="email-subject-and-more-button">
          <span>{{ 'emailWorkWidget.subjectAndMore' | translate }}</span>
        </a>
      </div>
      <div class="control-panel-group control-panel-group-action">
        <a (click)="onTransferClick()" class="btn btn-light js-assign-email-button" id="email-transfer-button">
          <span>{{ 'emailWorkWidget.transfer' | translate }}</span>
        </a>
        <a *ngIf="hasWrapUps" (click)="onWrapUpClick()" class="btn btn-light js-wrap-up-button" id="email-wrap-up-button">
          <span>{{ 'emailWorkWidget.wrapUp' | translate }}</span>
        </a>
        <a (click)="onCloseEmailClick()" class="btn btn-light js-close-email-button" id="email-close-button">
          <span>{{ 'emailWorkWidget.closeEmail' | translate }}</span>
        </a>
        <a (click)="onCancelEmailClick()" class="btn btn-light js-cancel-email-button" id="email-cancel-button">
          <span>{{ 'emailWorkWidget.cancel' | translate }}</span>
        </a>
      </div>
    </div>
  </div>
</div>
